import { ActionCardDto } from "api"

/**
 * Values of `ActionCardDto.displayOn` (DLK-1081). The generated DTO types the
 * field as a bare int; the generated `DisplayOn` string enum is only the
 * `device` query param, not these wire values. Anything else shows on both.
 */
export const CardDisplayOn = {
  Mobile: 1,
  Desktop: 2,
  Both: 3,
} as const satisfies Record<string, ActionCardDto["displayOn"]>
